import React, { Component } from "react";
import RenderTable from "../common/table";
import { Icon } from "semantic-ui-react";
import auth from "../../services/authService";

class TeacherTable extends Component {
  columns = [
    {
      path: "full_name",
      label: "Member",
      width: "4",
      content: (type) => type.full_name + " S/O " + type.father_name,
    },
    {
      path: "mobile",
      label: "Mobile",
      width: "2",
    },
    {
      path: "country",
      label: "Current Location",
      width: "3",
      content: (type) => type.city + " / " + type.region + " / " + type.country,
    },
    {
      path: "village",
      label: "Village",
      width: "2",
      content: (type) => (type.village != null ? type.village.name : ""),
    },
    {
      path: "profession",
      label: "Education/Profession",
      width: "4",
      content: (type) => type.education + " / " + type.profession,
    },
    {
      key: "actions",
      width: "1",
      content: (type) => (
        //auth.getCurrentUser().email === "company-unblocker@gondalgroup.ae" && (
        <div>
          <Icon
            name="trash"
            color="red"
            className="clickable"
            onClick={() => this.props.onDelete(type)}
          />

          <Icon
            name="edit"
            color="blue"
            className="clickable"
            onClick={() => this.props.onUpdate(type)}
          />
        </div>
      ),
      // )
    },
  ];

  render() {
    const { types, onSort, sortColumn } = this.props;

    return (
      <RenderTable
        columns={this.columns}
        data={types}
        sortColumn={sortColumn}
        onSort={onSort}
      />
    );
  }
}

export default TeacherTable;
